import * as api from '../../api/caso-general-client';
import { 
    GET_CONFIG_FORM,
    GET_CONFIG_FORM8,
    GET_CONFIG_FORM9,
    GET_ANTECEDENTES_CASO,
    GET_LIQUIDACION_PERDIDA,
    GET_DOCUMENTACION,
    GET_SELECT_DOCUMENTACION,
    GET_CASO_IMPLICADO,
    GET_ANTECEDENTES_LIQUIDACION,
    GET_DETALLES,
    GET_TIPOVEHICULOS,
    GET_MARCAS,
    GET_COMPANIAS,
    GET_SEGUROS,
    GET_REQUISITOS,
    ENVIAR_REQUISITOS_SELECCIONADOS,
    OBTENER_LLAVES,
    GET_CLASIFICA_RESPUESTA,
    GET_MOTIVO,
    GET_ESTADO_ACCION,
    POST_CARTA_COBRO,
    POST_RESPUESTA_COBRO,
    GET_CONFIG_FORM_IMPLICADO,
    GET_HITOS_CASO,
    GET_CONFIG_FORM33,
  
 
} from '../types';



export const configuracionFormAction = (query) => ({
    type: GET_CONFIG_FORM,
    payload: api.getConfiguracionForm(query)
});
export const configuracionFormActionImplicado = (query) => ({
    type: GET_CONFIG_FORM_IMPLICADO,
    payload: api.getConfiguracionFormImplicado(query)
});
export const configuracionFormAction8 = (query) => ({
    type: GET_CONFIG_FORM8,
    payload: api.getConfiguracionForm8(query)
});
export const configuracionFormAction9 = (query) => ({
    type: GET_CONFIG_FORM9,
    payload: api.getConfiguracionForm9(query)
});

export const obtenerAntecedentesCaso = (query) => ({
    type: GET_ANTECEDENTES_CASO,
    payload: api.getAntecedentes(query)
});
export const obtenerLiquidacionPerdida = (query) => ({
    type: GET_LIQUIDACION_PERDIDA,
    payload: api.getLiquidacionPerdida(query)
});


export const obtenerDocumentacion = (query) => ({
    type: GET_DOCUMENTACION,
    payload: api.getDocumentacion(query)
});

export const obtenerSelectDocumentacion = (query) => ({
    type: GET_SELECT_DOCUMENTACION,
    payload: api.getSelectDocumentacion(query)
});
export const obtenerCasoImplicado = (query) => ({
    type: GET_CASO_IMPLICADO,
    payload: api.getCasoImplicado(query)
});
export const obtenerAntecendentesLiquidacion = (query) => ({
    type:GET_ANTECEDENTES_LIQUIDACION,
    payload: api.getAntecendentesLiquidacion(query)
});
export const obtenerDetalles = (query) => ({
    type:GET_DETALLES,
    payload: api.getDetalles(query)
});
export const obtenerVehiculos = (query) => ({
    type:GET_TIPOVEHICULOS,
    payload: api.getTipoVehiculos(query)
});
export const obtenerRequisitos = (query) => ({
    type:GET_REQUISITOS,
    payload: api.getRequisitos(query)
});
export const EnviarRequisitosSeleccionados = (req) => ({
    type:ENVIAR_REQUISITOS_SELECCIONADOS,
    payload: req
});
export const obtenerDatosLlaves = (llaves) => ({
    type:OBTENER_LLAVES,
    payload: llaves
});
export const ObtenerMarcas = (query) => ({
    type:GET_MARCAS,
    payload: api.getMarcas(query)
});
export const ObtenerCompanias = (query) => ({
    type:GET_COMPANIAS,
    payload: api.getcompanias(query)
});
export const ObtenerSeguros = (query) => ({
    type:GET_SEGUROS,
    payload: api.getSeguros(query)
});
export const ObtenerClasificaRespuesta = (query) => ({
    type:GET_CLASIFICA_RESPUESTA,
    payload: api.getClasificaRespuesta(query)
});
export const ObtenerMotivo = (query) => ({
    type:GET_MOTIVO,
    payload: api.getMotivo(query)
});
export const ObtenerEstadoAccion = (query) => ({
    type:GET_ESTADO_ACCION,
    payload: api.getEstadoAccion(query)
});
export const PostCartaCobro = (newCarta) => ({
    type:POST_CARTA_COBRO,
    payload: api.enviarCartaCobro(newCarta)
});
export const PostRespuestaCobro = (newRespuesta) => ({
    type:POST_RESPUESTA_COBRO,
    payload: api.enviarRespuestaCobro(newRespuesta)
});
export const ObtenerHitosCaso = (query) => ({
    type:GET_HITOS_CASO,
    payload: api.getHitosCaso(query)
});
export const configuracionFormAction33 = (query) => ({
    type:GET_CONFIG_FORM33,
    payload: api.getConfiguracionForm33(query)
});
